import { render } from "./VocabularyTest.vue?vue&type=template&id=4f291773&scoped=true"
import script from "./VocabularyTest.vue?vue&type=script&lang=js"
export * from "./VocabularyTest.vue?vue&type=script&lang=js"

import "./VocabularyTest.vue?vue&type=style&index=0&id=4f291773&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f291773"]])

export default __exports__